<template>
  <div class="ticket-table-card">
    <div class="table-title">{{ticketTableTitle}}</div>
    <el-table :data="tableData"
              style="width: 100%"
              max-height="300">
      <!-- 序号 -->
      <el-table-column type="index"
                       :label="this.$t('alarmHistory.index')"
                       width="100">
      </el-table-column>
      <!-- 机柜编码 -->
      <el-table-column prop="cabinetNo"
                       :label="this.$t('serviceSupport.cabinetNumCode')">
      </el-table-column>
      <!-- 房间号 -->
      <el-table-column prop="roomNo"
                       :label="this.$t('serviceSupport.roomNum')">
      </el-table-column>
      <!-- 机柜类型 -->
      <!-- <el-table-column prop="cabinetType"
                       :label="this.$t('serviceSupport.cabinetType')">
      </el-table-column> -->
      <!-- 加电状态 -->
      <!-- <el-table-column prop="cabinetOpenStatus"
                       :label="this.$t('cabinetPowerUp.powerStatus')">
        <template slot-scope="scope">
          <span>{{scope.row.cabinetOpenStatus | maybeEmpty}}</span>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>
<script>
import cloneDeep from 'lodash';

export default {
  props: {
    tableData: {
      type: Array,
      default () { return null; },
    },
    ticketTableTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    ticketInfoTableCopy () {
      return cloneDeep(this.ticketInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-title {
  height: 40px;
  line-height: 40px;
  background-color: #f3f7fb;
  border: 1px solid #d9e1e9;
  font-size: 13px;
  border-bottom: none;
  padding-left: 8px;
}
.ticket-table-card {
  margin: 10px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/cabinet-powerUp/opt/ShowCabinetsDetail.vue